import Model from '@/lib/data/Model';
import Rule from './Rule';

class RulexCDT extends Model {
    static idProperty = 'id';

    fields = [
        'id',
        {
            name: 'control_data_table_id',
        },
        {
            name: 'rule_id',
        },
        {
            name: 'rules',
            // defaultValue: [],
            association: {
                type: 'many',
                model: Rule,
                // ,
                // collectionConfig: {
                //     url: '/forms/form/sections',
                //     method: 'GET'
                // }
            },
        },
        {
            name: 'record_state',
        },
    ];

    constructor(data) {
        super(data);
        this.init();
    }

    api = [
        // {
        //     name: 'saveRules',
        //     url: '/form/rule/save',
        //     associated: true
        // }
        // ,
        // {
        //     name: 'formDetailUpdate',
        //     url: '/mobile/visit/form/save',
        //     params: ['id', 'survey_info_id', 'values', 'l']
        // },
        // {
        //     name: 'create',
        //     url: '/forms/form',
        //     associated: true
        // },
        // {
        //     name: 'update',
        //     url: '/forms/form',
        //     associated: true
        // },
        // {
        //     name: 'destroy',
        //     url: '/forms/form',
        //     method: 'DELETE'
        // },
        // {
        //     name: 'saveQuestionsOrder',
        //     url: '/forms/form/questions/order',
        //     params: ['question_ids']
        // },
        // {
        //     name: 'saveSectionsOrder',
        //     url: '/forms/form/sections/order',
        //     params: ['sections_ids']
        // }
    ];
}

export default RulexCDT;
